<form
  class="row row-cols-auto g-1"
  [formGroup]="zonedDateForm"
  [ngbTooltip]="readonly ? notAuthorized : false"
  >
  @if (displayLabel) {
    <label
      class="fw-normal col-12 col-sm-2 col-l-1 col-form-label-sm"
      i18n
    >Date</label>
  }
  <div class="col row g-1">
    <div class="col input-group input-group-sm">
      <input
        required
        [readonly]="readonly"
        #picker1="ngbDatepicker"
        #dateInput
        [placeholder]="(dateFormat | uppercase)"
        ngbDatepicker
        [minDate]="_minDateAsNgb"
        [maxDate]="_maxDateAsNgb"
        formControlName="date"
        class="form-control form-control-sm flex-adapt"
        type="text"
        />
      <div class="input-group-append">
        <button
          class="btn btn-sm btn-light"
          [disabled]="readonly"
          (click)="picker1.toggle()"
          type="button"
          >
          <svg-icon
            name="calendar-choice"
            [svgStyle]="{'height.pc':1,'width.pc':1}"
          ></svg-icon>
        </button>
      </div>
    </div>
    <ngb-timepicker
      required
      [readonlyInputs]="readonly"
      class="col-auto"
      [spinners]="false"
      size="small"
      formControlName="time"
      [minuteStep]="timeStep"
      (keyup)="handleTimePickerKeyUpEvent($event)"
    ></ngb-timepicker>
    <!-- NOW BUTTON -->
    <div class="col-auto">
      <button
        class="btn btn-sm btn-light"
        [disabled]="readonly"
        i18n-ngbTooltip
        ngbTooltip="Now"
        (click)="setDateToNow()"
        >
        <svg-icon
          name="calendar"
          [svgStyle]="{'height.pc':1,'width.pc':1}"
        ></svg-icon>
      </button>
    </div>
  </div>
</form>
<ng-template
  #notAuthorized
  i18n
>Not authorized</ng-template>